export default {"src":"/_next/static/media/betaald-parkeren.62f48f2d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};